import { SummaryItemDto, SummaryItemModel } from 'api/dto/new/Common/SummaryItem.dto';
import { SimpleProject } from 'model/SimpleProject';
import {
  MonthlyAggregatedScoreDto,
  MonthlyAggregatedScoreModel,
} from 'api/dto/new/Common/MonthlyAggregatedScore.dto';
import {
  QuestionItemContainingOpinionQuestionWithMonthlyAggregatedTrendDataDto,
  QuestionItemContainingOpinionQuestionWithMonthlyAggregatedTrendDataModel,
} from 'api/dto/new/Common/QuestionItemContainingOpinionQuestionWithMonthlyAggregatedTrendData.dto';
import { summaryMapper } from 'container/summaryMapper';

export type SummaryPulseLifecycleCombinedDto = {
  numberOfRespondents: number;
  monthlyAggregatedRecommendationData: MonthlyAggregatedScoreDto[];
  questions: QuestionItemContainingOpinionQuestionWithMonthlyAggregatedTrendDataDto[];
  summary: SummaryItemDto;
};

export type SummaryPulseLifecycleCombinedModel = {
  numberOfRespondents: number;
  monthlyAggregatedRecommendationData: MonthlyAggregatedScoreModel[];
  questions: QuestionItemContainingOpinionQuestionWithMonthlyAggregatedTrendDataModel[];
  summary: SummaryItemModel;
};

export const mapSummaryPulseLifecycleCombinedDtoToSimpleProjectCombine = (
  dto: SummaryPulseLifecycleCombinedDto
): SimpleProject.Combine => {
  return {
    summary: summaryMapper.deserializeCombine(dto.summary as any),
    simpleProject: {
      numberOfEmployees: dto.numberOfRespondents,
      recommendPlotData:
        dto.monthlyAggregatedRecommendationData?.map((item) => ({
          date: item.date,
          value: item.value ?? null,
        })) ?? [],
      questions:
        dto.questions?.map(({ question, score, feedback }) => ({
          score: score,
          question: {
            id: question.id,
            content: question.content,
            trendPlotData: question.monthlyAggregatedTrendData?.map((trend) => trend.value ?? null),
          },
          feedback: feedback.map(({ label, value, options }) => ({
            label,
            value,
            options:
              Array.isArray(options) && options.length > 0
                ? (options.slice(0, 2) as [string] | [string, string])
                : undefined,
          })),
        })) ?? [],
    },
  };
};

// TODO: use this mapper later for new endpoint proper typing - https://buzzing.atlassian.net/browse/RPT-321
// export const mapSummaryPulseLifecycleCombinedDtoToModel = (
//   dto: SummaryPulseLifecycleCombinedDto
// ): SummaryPulseLifecycleCombinedModel => {
//   return {
//     numberOfRespondents: dto.numberOfRespondents,
//     monthlyAggregatedRecommendationData: dto.monthlyAggregatedRecommendationData.map(
//       mapMonthlyAggregatedScoreDtoToModel
//     ),
//     questions: dto.questions.map(
//       mapQuestionItemContainingOpinionQuestionWithMonthlyAggregatedTrendDataDtoToModel
//     ),
//     summary: mapSummaryItemDtoToModel(dto.summary),
//   };
// };
